import React, { FC, ReactElement } from "react";

import { Typography } from "@mui/material";
import Divider from "@mui/material/Divider";

import KeyPairPicker from "../../../../components/Redux/KeyPairPicker";
import Switch from "../../../../components/Redux/Switch";
import { ReduxTextField } from "../../../../components/Redux/TextField";
import SettingSection from "../../../../components/SettingSection";
import Link from "../../../../components/styled/Link";
import TabSection from "../../../../components/styled/TabSection";
import {
  getRouteFormProperty,
  setRouteFormError,
  setRouteFormProperty,
} from "../../../../slices/routes";
import { KeyPair } from "../../../../store/pomeriumApi";
import { PickerType } from "../../../../types/KeyPairPicker";
import { SectionProps } from "./common";

type TLSProps = SectionProps & {
  routeId?: string;
  matchingCertificates: KeyPair[];
};

export const TLS: FC<TLSProps> = ({
  readonly,
  tabValue,
  routeId,
  matchingCertificates,
}): ReactElement => {
  return (
    <TabSection index={"tls"} value={tabValue} title="TLS">
      {routeId && (
        <>
          <SettingSection
            label="Matching Certificate"
            docsKey="matching-certificate"
          >
            {matchingCertificates?.length ? (
              <Typography variant="body1">
                <Link
                  to={`/app/management/certificates/${matchingCertificates[0]?.id}`}
                >
                  {matchingCertificates[0]?.name}
                </Link>
              </Typography>
            ) : (
              <Typography component="em">No Certificate Found</Typography>
            )}
          </SettingSection>
          <Divider />
        </>
      )}
      <SettingSection
        label="TLS Upstream Server Name"
        docsKey="tls-upstream-server-name"
      >
        <ReduxTextField
          disabled={readonly}
          fullWidth
          setter={setRouteFormProperty}
          getter={getRouteFormProperty}
          path="tlsUpstreamServerName"
          errorHandler={setRouteFormError}
        />
      </SettingSection>
      <Divider />
      <SettingSection
        label="TLS Downstream Server Name"
        docsKey="tls-downstream-server-name"
      >
        <ReduxTextField
          disabled={readonly}
          fullWidth
          setter={setRouteFormProperty}
          getter={getRouteFormProperty}
          errorHandler={setRouteFormError}
          path="tlsDownstreamServerName"
        />
      </SettingSection>
      <Divider />
      <SettingSection label="TLS Skip Verify" docsKey="tls-skip-verification">
        <Switch
          path="tlsSkipVerify"
          label=""
          disabled={readonly}
          setter={setRouteFormProperty}
          getter={getRouteFormProperty}
          errorHandler={setRouteFormError}
        />
      </SettingSection>
      <Divider />
      <SettingSection
        label="TLS Custom Certificate Authority"
        docsKey="tls-custom-certificate-authority"
      >
        <KeyPairPicker
          disabled={false}
          setter={setRouteFormProperty}
          getter={getRouteFormProperty}
          pickerType={PickerType.CertificateAuthority}
          path="tlsCustomCaKeyPairId"
        />
      </SettingSection>
      <Divider />
      <SettingSection
        label="TLS Client Certificate"
        docsKey="tls-client-certificate"
      >
        <KeyPairPicker
          disabled={false}
          setter={setRouteFormProperty}
          getter={getRouteFormProperty}
          pickerType={PickerType.ClientCertificate}
          path="tlsClientKeyPairId"
        />
      </SettingSection>
      <Divider />
      <SettingSection
        label="TLS Upstream Allow Renegotiation"
        docsKey="tls-upstream-allow-renegotiation"
      >
        <Switch
          path="tlsUpstreamAllowRenegotiation"
          label=""
          disabled={readonly}
          setter={setRouteFormProperty}
          getter={getRouteFormProperty}
          errorHandler={setRouteFormError}
        />
      </SettingSection>
    </TabSection>
  );
};
